import React from "react";
import "./Integrated_Institute.css";
import Explore_Btn from "../../common/explore-btn/Explore_Btn";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { AllProgramList } from "../../../features/admin/common/Slice";


const Integrated_Institute = () => {
  const navigate = useNavigate();
  const program_list = useSelector((state) => state?.common?.all_program_list);
  return (
    <section className="Integrated_Institute">
      <div className="container">
        <div className="Integrated_Institute_content_holder">
          <div className="row align-items-center justify-content-center">
            <div className="col-lg-5 col-md-6 col-sm-7">
              <div className="left_col_div">
                <div className="top_btn_holder">
                  <div className="top_btn"> Offline</div>
                  <div className="top_btn"> Online</div>
                  <div className="top_btn"> Affordable</div>
                </div>

                <p className="col_subtitle">
                  PG Program In Data Engineering & Data Science
                </p>

                <div className="col_text_holder">
                  <p className="india">India's Leading</p>
                  <h5 className="industry">industry integrated</h5>
                  <h5 className="industry">Institute</h5>
                </div>

                <div className="explore_btn">
                  {/* <Explore_Btn onClick={()=>navigate("/explore-program")}/> */}
                  <Explore_Btn
                    onClick={() => {
                      if (program_list?.length > 0) {
                        navigate(`/explore-program/${program_list[0].id}`);
                      }
                    }}
                  />
                </div>
              </div>
            </div>

            <div className="col-lg-5 col-md-6 col-sm-5">
              <div className=" right_img_holder">
                <img
                  src="/assets/images/home/Integrated_Institute/right-img.png"
                  alt="banner-img"
                  className="right_img"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Integrated_Institute;
